import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { MtAccount } from "server/models"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    Logo,
    Expired,
    TableColumn,
    TablePopover,
    TablePopoverData,
} from "client/components"

import AssignedUserGroups from "client/pages/mt/userGroups/assigned"

const Columns = (userId: number) => {
    const groupList = useSelector((state: StoreType) => state.group.groupList)
    const accountGroupList = useSelector((state: StoreType) => state.userGroup.accountGroupList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (account: MtAccount) => <Logo table logo={account.logo || Images.accountLogo} />,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (account: MtAccount) => {
                let demo = null
                if (account.demoExpiry !== null) {
                    const expiryDate = new Date(account.demoExpiry).getTime()
                    const now = new Date().getTime()
                    demo = ((expiryDate - now) < 0) ? lang.demoExpired : lang.demo
                }
                return (
                    <>
                        {account.shortName ? `${account.name} (${account.shortName})` : account.name}
                        {demo && <Expired>{demo}</Expired>}
                    </>
                )
            },
        },
        {
            field: "groups",
            header: lang.groups,
            cellMinWidth: "150px",
            formatter: (account: MtAccount) => {
                // Super Admin account has no groups
                if (!groupList || Object.keys(groupList).length === 0 || !accountGroupList || account.id === 1) return null

                const groupIds = accountGroupList[account.id] || []
                const dataList: TablePopoverData[] = []
                groupIds.forEach((groupId) => {
                    const group = groupList[groupId]
                    dataList.push({
                        id: `${account.id}_${group.id}`,
                        title: group.name,
                    })
                })

                return (
                    <TablePopover
                        id={`accountGroups${account.id}`}
                        dataList={dataList}
                        placement="left"
                        title={lang.groups}
                        editAccess
                        onClick={() => dispatch(addModal({
                            key: "AssignedUserGroups",
                            content: <AssignedUserGroups accountId={account.id} userId={userId} />,
                        }))}
                    />
                )
            },
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => true, // only Super Admin can deactivate users
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        },
    ]

    return columns
}
export default Columns
